import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-subheading gfu-subheading--main" }
const _hoisted_2 = {
  key: 0,
  id: "notify",
  class: "gfu-notificator _mt-3",
  "data-qa": "notificator-item-info:ChangeAddressNotAllowed"
}
const _hoisted_3 = {
  class: "gfu-notificator-item gfu-notificator-item--permanent gfu-notificator-item--has-actions",
  "data-qa": "notificator-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_steps_indicator = _resolveComponent("steps-indicator")
  const _component_payment_checkout_header = _resolveComponent("payment-checkout-header")
  const _component_legacy_cart_table = _resolveComponent("legacy-cart-table")
  const _component_checkout_return_actions = _resolveComponent("checkout-return-actions")
  const _component_legacy_begin_order_form = _resolveComponent("legacy-begin-order-form")
  const _component_checkout_footer = _resolveComponent("checkout-footer")
  const _component_box = _resolveComponent("box")
  const _component_project_context_modal = _resolveComponent("project-context-modal")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, {
    class: "gfu-layout__main gfu-layout__main--narrow",
    "is-processing": _ctx.isProcessing,
    "data-qa": "begin-order-form"
  }, {
    default: _withCtx(() => [
      ($options.isStepIndicatorVisible)
        ? (_openBlock(), _createBlock(_component_steps_indicator, {
            key: 0,
            steps: $props.steps
          }, null, 8 /* PROPS */, ["steps"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("h1", {
        class: _normalizeClass(['gfu-heading gfu-heading--main', {'_mt-6': !$options.isStepIndicatorVisible}]),
        "data-qa": "page-title"
      }, _toDisplayString(_ctx.Resources.Checkout.ShippingPageHeader), 3 /* TEXT, CLASS */),
      _createElementVNode("div", _hoisted_1, _toDisplayString($options.subheaderText), 1 /* TEXT */),
      _createVNode(_component_box, { class: "_mt-3 _mb-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_payment_checkout_header, _normalizeProps(_guardReactiveProps($options.paymentCheckoutHeaderPropsModel)), null, 16 /* FULL_PROPS */),
          _createVNode(_component_legacy_cart_table, _normalizeProps(_guardReactiveProps($options.cartTableModelFormatted)), null, 16 /* FULL_PROPS */),
          _createVNode(_component_checkout_return_actions, _normalizeProps(_guardReactiveProps($props.checkoutReturnActionsModel)), null, 16 /* FULL_PROPS */),
          _createElementVNode("div", null, [
            ($props.isNotificationVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Checkout.ShippingFormNotificatorParagraph), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_legacy_begin_order_form, {
              "phone-number-required": $props.phoneNumberRequired,
              "force-same-billing-location-id": $props.forceSameBillingLocationId,
              "show-address-line2": $props.showAddressLine2,
              "show-address-line3": $props.showAddressLine3,
              "handle-tax": $props.handleTax,
              "customer-information-required": $props.customerInformationRequired,
              "enable-invoicing": $props.enableInvoicing,
              "check-items-integrity": $props.checkItemsIntegrity,
              "is-order-amended": $props.isOrderAmended,
              "is-order-with-early-taxes": $props.isOrderWithEarlyTaxes,
              "disable-address-change": $props.disableAddressChange,
              "order-code": $props.orderCode,
              "url-back-to-cart": $props.urlBackToCart,
              "url-contact-form": $props.urlContactForm,
              "project-is-digital-only": $props.projectIsDigitalOnly,
              "order-id": $props.orderId,
              onContinue: $options.onContinue
            }, null, 8 /* PROPS */, ["phone-number-required", "force-same-billing-location-id", "show-address-line2", "show-address-line3", "handle-tax", "customer-information-required", "enable-invoicing", "check-items-integrity", "is-order-amended", "is-order-with-early-taxes", "disable-address-change", "order-code", "url-back-to-cart", "url-contact-form", "project-is-digital-only", "order-id", "onContinue"])
          ]),
          _createVNode(_component_checkout_footer, { "show-digital-content-info": $props.requireWithdrawalConsent }, null, 8 /* PROPS */, ["show-digital-content-info"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_project_context_modal)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-processing"]))
}